import qrcode from 'qrcode'
import { useEffect, useState } from 'react'

export const QrCode = ({ spaydString }: { spaydString: string }) => {
  const [qrCode, setQrCode] = useState<string | null>(null)

  useEffect(() => {
    qrcode
      .toDataURL(spaydString, {
        // type: 'svg',
        width: 120,
        margin: 0,
        color: {
          dark: '#000000',
          light: '#ffffff',
        },
      })
      .then((url) => {
        setQrCode(url)
      })
      .catch(console.error)
  }, [])

  return (
    <div>
      {qrCode && (
        <img
          src={qrCode}
          alt=""
          width={120}
          height={120}
          onClick={async () => {
            const shareData: ShareData = {
              title: 'Pltaba přes QR kód',
              files: [
                new File([qrCode], 'qr-code.png', {
                  type: 'image/png',
                }),
              ],
            }

            try {
              await navigator.share(shareData)
            } catch (err) {
              console.error(err)
            }
          }}
        />
      )}
    </div>
  )
}
